import type { RouteRecordRaw } from "vue-router";

import { ROUTE_BASE_NAME, ROUTE_NAMES } from "./config";

export const routes: RouteRecordRaw[] = [
  {
    path: "devices",
    name: ROUTE_BASE_NAME,
    component: () => import("./views/DevicesMain.vue"),
    redirect: { name: ROUTE_NAMES.List },
    meta: {
      breadcrumb: "Devices",
    },
    children: [
      {
        path: "",
        name: ROUTE_NAMES.List,
        component: () => import("./views/DevicesList.vue"),
      },
      // {
      //   path: "create",
      //   name: ROUTE_NAMES.Create,
      //   component: () => import("./views/DevicesCreate.vue"),
      //   meta: {
      //     breadcrumb: "New device",
      //   },
      // },
      {
        path: "edit/:id",
        name: ROUTE_NAMES.Update,
        component: () => import("./views/DevicesUpdate.vue"),
        meta: {
          breadcrumb: "Update device",
        },
      },
    ],
  },
];
